/* DD collection filters: instant filtering via the Section Rendering API, dropdowns + phone sheets. */
(function () {
  var state = { open: null, sheet: null, scroll: 0 };
  var ctrl = null;
  var ticking = false;

  function root() { return document.getElementById('DDCollection'); }
  function params() { return new URLSearchParams(location.search); }

  function setTop() {
    var r = root();
    if (!r) return;
    var h = document.querySelector('.section-header');
    var t = 0;
    if (h) t = Math.max(0, Math.round(h.getBoundingClientRect().bottom));
    r.style.setProperty('--ddf-top', t + 'px');
  }

  /* ---------- dropdowns ---------- */
  function closePop() {
    var r = root();
    if (!r) return;
    r.querySelectorAll('.ddf-dd').forEach(function (dd) {
      var pop = dd.querySelector('.ddf-pop');
      var btn = dd.querySelector('[data-toggle]');
      if (pop) pop.hidden = true;
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
    state.open = null;
  }
  function openPop(key) {
    closePop();
    var r = root();
    var dd = r && r.querySelector('.ddf-dd[data-key="' + key + '"]');
    if (!dd) return;
    dd.querySelector('.ddf-pop').hidden = false;
    dd.querySelector('[data-toggle]').setAttribute('aria-expanded', 'true');
    state.open = key;
  }

  /* ---------- sheets ---------- */
  function openSheet(name, instant) {
    var r = root();
    var s = r && r.querySelector('[data-sheet-panel="' + name + '"]');
    if (!s) return;
    s.hidden = false;
    if (instant) s.classList.add('is-open');
    else requestAnimationFrame(function () { requestAnimationFrame(function () { s.classList.add('is-open'); }); });
    document.documentElement.classList.add('ddf-lock');
    state.sheet = name;
  }
  function closeSheet() {
    var r = root();
    if (!r) return;
    r.querySelectorAll('.ddf-sheet').forEach(function (s) {
      s.classList.remove('is-open');
      setTimeout(function () { if (!s.classList.contains('is-open')) s.hidden = true; }, 300);
    });
    document.documentElement.classList.remove('ddf-lock');
    state.sheet = null;
  }

  /* ---------- fetch + swap ---------- */
  function go(p, push) {
    var r = root();
    if (!r) return;
    p.delete('page');
    var qs = p.toString();
    var url = location.pathname + (qs ? '?' + qs : '');
    var body = r.querySelector('[data-sheet-body]');
    state.scroll = body ? body.scrollTop : 0;
    r.classList.add('is-loading');
    if (ctrl) ctrl.abort();
    ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    fetch(url + (qs ? '&' : '?') + 'section_id=' + encodeURIComponent(r.dataset.sectionId), ctrl ? { signal: ctrl.signal } : {})
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('DDCollection');
        if (!fresh) { location.href = url; return; }
        var open = state.open, sheet = state.sheet, scroll = state.scroll;
        r.innerHTML = fresh.innerHTML;
        r.classList.remove('is-loading');
        if (push !== false) history.pushState({ ddf: 1 }, '', url);
        if (open) openPop(open);
        if (sheet) {
          openSheet(sheet, true);
          var nb = r.querySelector('[data-sheet-body]');
          if (nb) nb.scrollTop = scroll;
        }
        setTop();
        document.dispatchEvent(new CustomEvent('ddf:updated'));
      })
      .catch(function (e) { if (!e || e.name !== 'AbortError') location.href = url; });
  }

  function toggleValue(p, param, value) {
    var vals = p.getAll(param);
    p.delete(param);
    if (vals.indexOf(value) > -1) vals = vals.filter(function (x) { return x !== value; });
    else vals.push(value);
    vals.forEach(function (x) { p.append(param, x); });
  }
  function clearParam(p, prefix) {
    Array.from(p.keys()).forEach(function (k) {
      if (k === prefix || k.indexOf(prefix + '.') === 0) p.delete(k);
    });
  }
  function applyPrice(scope) {
    var p = params();
    clearParam(p, 'filter.v.price');
    scope.querySelectorAll('[data-price-input]').forEach(function (inp) {
      var v = (inp.value || '').replace(/[^\d.]/g, '');
      if (v !== '') p.set('filter.v.price.' + inp.dataset.priceInput, v);
    });
    go(p);
  }

  /* ---------- events ---------- */
  document.addEventListener('click', function (e) {
    var r = root();
    if (!r) return;
    var inside = r.contains(e.target);
    if (state.open && !e.target.closest('.ddf-dd')) closePop();
    if (!inside) return;
    var t = e.target.closest('button, [data-sheet-close]');
    if (!t) return;
    var d = t.dataset;

    if (d.toggle) { var k = d.toggle; state.open === k ? closePop() : openPop(k); return; }
    if (d.close !== undefined) { closePop(); return; }
    if (d.sheet) { closePop(); openSheet(d.sheet); return; }
    if (d.sheetClose !== undefined) { closeSheet(); return; }

    var p = params();
    if (d.param) { toggleValue(p, d.param, d.value); go(p); return; }
    if (d.priceLo !== undefined) {
      var on = t.getAttribute('aria-pressed') === 'true';
      clearParam(p, 'filter.v.price');
      if (!on) {
        if (d.priceLo) p.set('filter.v.price.gte', d.priceLo);
        if (d.priceHi) p.set('filter.v.price.lte', d.priceHi);
      }
      go(p); return;
    }
    if (d.priceApply !== undefined) { applyPrice(t.closest('.ddf-range')); return; }
    if (d.clear) { clearParam(p, d.clear); go(p); return; }
    if (d.clearAll !== undefined) {
      Array.from(p.keys()).forEach(function (k) { if (k.indexOf('filter.') === 0) p.delete(k); });
      go(p); return;
    }
    if (d.sort) {
      p.set('sort_by', d.sort);
      closePop();
      if (state.sheet === 'sort') closeSheet();
      go(p); return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closePop(); if (state.sheet) closeSheet(); }
    if (e.key === 'Enter' && e.target.matches && e.target.matches('.ddf [data-price-input]')) {
      e.preventDefault();
      applyPrice(e.target.closest('.ddf-range'));
    }
  });

  window.addEventListener('popstate', function () { if (root()) go(params(), false); });
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { ticking = false; setTop(); });
  }, { passive: true });
  window.addEventListener('resize', setTop);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setTop);
  else setTop();
})();
